'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _loadjs = require('loadjs');

var _loadjs2 = _interopRequireDefault(_loadjs);

require('../../styles/templates/gift_card.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scriptsEl = document.querySelector('[data-scripts]');
var scripts = JSON.parse(scriptsEl.innerHTML);

var TemplateGiftCard = function () {
  function TemplateGiftCard(template) {
    (0, _classCallCheck3.default)(this, TemplateGiftCard);

    this.el = template.el;
    return this.addQrCode();
  }

  (0, _createClass3.default)(TemplateGiftCard, [{
    key: 'addQrCode',
    value: function addQrCode() {
      var qrWrapper = this.el.querySelector('[data-qr-code]');

      return new QRCode(qrWrapper, {
        text: qrWrapper.data('qr-code'),
        width: 120,
        height: 120
      });
    }
  }]);
  return TemplateGiftCard;
}();

exports.default = TemplateGiftCard;


(0, _loadjs2.default)(scripts.qrcode, function () {
  new TemplateGiftCard({ el: document.body });
});